export var baseApiUrl = "/api";
export var Environments = new Map();
Environments.set("dev", "https://pay.dev.areto-payment.com/api");
Environments.set("stage", "https://pay.stage.areto-payment.com/api");
Environments.set("live", "https://pay.areto-payment.com/api");
// Environments.set('localhost', "https://localhost:44301/api");
Environments.set("localhost", "https://paymentwall.natapp4.cc/api");
